import { render, staticRenderFns } from "./ModalContentEmail.vue?vue&type=template&id=7b860a6d&scoped=true&"
import script from "./ModalContentEmail.vue?vue&type=script&lang=js&"
export * from "./ModalContentEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentEmail.vue?vue&type=style&index=0&id=7b860a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b860a6d",
  null
  
)

export default component.exports